interface Props {
    id: string
}

const ArrowLeftIcon = ({ id }: Props) => {
    return (
        <svg
            width="14"
            height="23"
            viewBox="0 0 14 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.8599 1.18381e-06C11.2739 1.13258e-06 10.8025 0.200001 10.3949 0.600001L0.802548 9.775C0.254777 10.3125 0.0127388 10.8375 -9.88375e-08 11.5C-1.55662e-07 12.15 0.254777 12.7 0.802548 13.225L10.3822 22.4125C10.8025 22.8 11.2866 23 11.8599 23C13.0318 23 14 22.075 14 20.925C14 20.35 13.7452 19.825 13.3121 19.3875L4.99363 11.4875L13.3121 3.6125C13.758 3.175 14 2.65 14 2.075C14 0.937501 13.0318 1.28627e-06 11.8599 1.18381e-06Z"
                fill={`url(#${id}-gradient)`}
            />
            <defs>
                <linearGradient
                    id={`${id}-gradient`}
                    x1="7"
                    y1="23"
                    x2="7"
                    y2="1.29539e-06"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E53D82" />
                    <stop offset="1" stopColor="#6518BF" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ArrowLeftIcon;
